import AmplifyConfig from "../aws-exports";
import { Amplify, AWSCloudWatchProvider, Logger } from "aws-amplify";

const logger = new Logger("Frontend Inspections Logs", "DEBUG");

Amplify.register(logger);

function formatDateISO(date) {
  // Convert the date to ISO string
  const isoString = date.toISOString();
  // Split at the "T" character to get the date part, replace dashes with slashes (AWS CloudWatch format)
  const formattedDate = isoString.split("T")[0].split("-").join("/");

  return formattedDate;
};

export function CloudWatchLogger(logGroupName, logType, logMessage, logData) {
  if (!logger?._pluggables?.length) {
    logger.addPluggable(
      new AWSCloudWatchProvider({
        logGroupName: logGroupName,
        logStreamName: formatDateISO(new Date()) + "/inspections-frontend-logs",
        region: AmplifyConfig.aws_project_region,
      })
    );
  }

  switch (logType) {
    case "error":
      logger.error(logMessage, JSON.stringify(logData, null, 2));
      break;
    case "warning":
      logger.warn(logMessage, JSON.stringify(logData, null, 2));
      break;
    case "info":
      logger.info(logMessage, JSON.stringify(logData, null, 2));
      break;
    case "debug":
      logger.debug(logMessage, JSON.stringify(logData, null, 2));
      break;
    default:
      console.log(
        "Invalid log type provided. Please use 'error', 'warning', 'info', or 'debug'."
      );
      return null;
  }

  return logger;
}
